import AcceptConcurrentMessagingSession from 'actions/concurrent_messaging/accept_concurrent_messaging_session';
import closeNotification from './lib/close_notification';
import IncomingConcurrentSessionNotification from 'models/notification/incoming_concurrent_session_notification';
import navigateToConversation from 'actions/conversation/lib/navigate_to_conversation';
import qconsole from 'scripts/lib/qconsole';
import TaskNotification from 'models/notification/task_notification';

export default class FollowIncomingNotification {
  constructor(context) {
    this.context = context;
  }

  run(incomingNotification) {
    let notification = getCurrentNotification(this.context, incomingNotification);
    if (!notification) {
      qconsole.log(`Could not find notification [${incomingNotification.id}] to accept`);
      return;
    }

    this.context.gateways.notification.delete(incomingNotification.id);
    closeNotification(this.context, incomingNotification.id);

    if (isIncomingConcurrentSessionNotification(notification)) {
      this.context.executeAction(AcceptConcurrentMessagingSession);
      return;
    }

    if (isTaskNotification(notification)) {
      navigateToConversation(this.context, {
        customerId: notification.profile.id,
        conversationId: notification.conversationId,
        conversationItemId: notification.conversationItem.id,
      });
      return;
    }

    navigateToConversation(this.context, {
      customerId: notification.profile.id,
      conversationId: notification.conversationId,
    });
  }
}

function getCurrentNotification(context, incomingNotification) {
  if (isIncomingConcurrentSessionNotification(incomingNotification)) {
    return incomingNotification;
  }

  return context.stores.notifications.findBy({ id: incomingNotification.id });
}

function isIncomingConcurrentSessionNotification(notification) {
  return notification instanceof IncomingConcurrentSessionNotification;
}

function isTaskNotification(notification) {
  return notification instanceof TaskNotification;
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/notification/follow_incoming_notification.js